import { render, staticRenderFns } from "./BaseNotification2.vue?vue&type=template&id=3fc930ac&"
import script from "./BaseNotification2.vue?vue&type=script&lang=js&"
export * from "./BaseNotification2.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotification2.vue?vue&type=style&index=0&id=3fc930ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports